import sanitize from 'sanitize-filename';
import { emojiRegex } from './string.utils';
export const sanitizeFileName = (filename: string) => {
  const removeEmoij = filename.replaceAll(emojiRegex, '');
  return sanitize(removeEmoij).replaceAll(' ', '-').replaceAll('#', '');
};
